import { Box, BoxProps } from '@amzn/ring-ui-react-components';

export interface DealsContainerProps extends BoxProps {
  noPadding?: boolean;
}

// Max width will be discussed with the design team, for now is set to 1366px to match Figma design
// https://www.figma.com/file/FXcSs8wKGD0YFt3orcJdUa/NHWEB---Main-Board?node-id=9227%3A77590
export const Container = ({
  maxWidth = 1600,
  noPadding,
  ...props
}: DealsContainerProps) => (
  <Box
    maxWidth={maxWidth}
    mt={0}
    mx="auto"
    px={{ base: noPadding ? 0 : 6, m: 10 }}
    width="100%"
    {...props}
  />
);
